
import { SWRConfiguration, SWRResponse } from "swr";

import { GetExternalUsers, GetExternalUsersResponse } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<GetExternalUsersResponse, GetExternalUsersResponse>) => response?.data?.users.sort((a, b) => a.username! > b.username! ? 1 : -1);
const getError = (response?: SWRResponse<GetExternalUsersResponse, GetExternalUsersResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetExternalUsersResponse, GetExternalUsersResponse>) => ({});

export const useConfigurationSourceDatas = (configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {

        return () => {
            return new GetExternalUsers();
        }
    }, []);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationSourceDatas;